/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Subtitle_StatInputs */

const he_home_subtitle_stat = /** @type {(inputs: Home_Subtitle_StatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מעקב מחירים על 300,000+ מוצרים. בחינם.`)
};

const en_home_subtitle_stat = /** @type {(inputs: Home_Subtitle_StatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price tracking on 300,000+ products. For free.`)
};

/**
* | output |
* | --- |
* | "Price tracking on 300,000+ products. For free." |
*
* @param {Home_Subtitle_StatInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_subtitle_stat = /** @type {((inputs?: Home_Subtitle_StatInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Subtitle_StatInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_subtitle_stat(inputs)
	return en_home_subtitle_stat(inputs)
});